function polyfill(): any {
  let local: any = {};
  if (typeof global !== "undefined") {
    local = global;
  } else if (typeof self !== "undefined") {
    local = self;
  } else {
    try {
      local = Function("return this")(); // jshint ignore:line
    } catch (e) {
      throw new Error("polyfill失败，因为在此环境中全局对象不可用");
    }
  }
  return local;
}

export { polyfill };
